import * as React from "react";
import type { GatsbyBrowser } from "gatsby";

import { Provider } from "./src/provider"; // Ensure correct path

import "./src/styles.css";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => <Provider forcedTheme={'dark'}>{element}</Provider>;
